import React, { useContext, useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import { ExpertCardListings as ExpertCardListingsComponent } from '@fiverr-private/listings';
import { EventReportingManagerContext } from '../../../../../../components/EventReportingManager';
import { withClientSideRender } from '../../../utils/withClientSideRender';
import { useEditorAsyncProps } from '../../hooks/useEditorAsyncProps';
import { useCurrencyObject } from '../../hooks/useCurrencyObject';
import type { CurrencyObject } from '../../hooks/useCurrencyObject/utils';
import type { ExpertCardListingsProps } from './types';

const COMPONENT_NAME = 'ExpertCardListings';

const ExpertCardListings = (props: ExpertCardListingsProps) => {
    const {
        items: propsItems,
        cardVariant,
        layout,
        currencyObject,
        forceSmallCard,
        showPrice,
        showHourlyPrice,
        source,
    } = props;

    const {
        context: {
            page: { name: pageName },
        },
    } = useContext(EventReportingManagerContext);

    const [items, setItems] = useState(propsItems);
    const editorAsyncProps: Record<string, any> = useEditorAsyncProps(COMPONENT_NAME);
    const currency = useCurrencyObject(currencyObject as CurrencyObject, COMPONENT_NAME);
    const expertCardListingsProps = {
        items,
        cardVariant,
        layout,
        forceSmallCard,
        currency,
        source: source || pageName,
        displayOptions: { showPrice },
        showHourlyPrice,
    };

    useEffect(() => {
        if (!isEmpty(editorAsyncProps?.items)) {
            setItems(editorAsyncProps.items);
        }
    }, [editorAsyncProps]);

    return <ExpertCardListingsComponent {...expertCardListingsProps} />;
};

export default withClientSideRender(ExpertCardListings);
